(function () {
  'use strict';
  function money(c) {
    var s = (c / 100).toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') { s = s.slice(0, -3); }
    return s + ' €';
  }

  document.querySelectorAll('[data-rv-product]').forEach(function (root) {
    var data = root.querySelector('[data-rv-variants]');
    if (!data) { return; }
    var variants = JSON.parse(data.textContent);
    var idInput = root.querySelector('[data-rv-variant-id]');
    var sets = root.querySelectorAll('[data-rv-option]');
    var main = root.querySelector('[data-rv-main]');

    function chosen() {
      var a = [];
      sets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        a.push(c ? c.value : null);
        var l = fs.querySelector('[data-rv-option-label]');
        if (l && c) { l.textContent = c.value; }
        if (c && c.hasAttribute('data-hex') && main) {
          main.style.setProperty('--rv-c', c.getAttribute('data-hex'));
          var n = main.querySelector('[data-rv-colour-name]');
          if (n) { n.textContent = c.value; }
        }
      });
      return a;
    }

    function update(push) {
      var a = chosen();
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === a[i]; });
      })[0];
      document.querySelectorAll('[data-rv-add]').forEach(function (b) {
        var withPrice = b.hasAttribute('data-rv-with-price');
        if (!v) { b.disabled = true; b.textContent = 'Indisponible'; return; }
        b.disabled = !v.available;
        b.textContent = v.available ? ('Ajouter au panier' + (withPrice ? ' · ' + money(v.price) : '')) : 'Épuisé';
      });
      if (!v) { return; }
      idInput.value = v.id;
      document.querySelectorAll('[data-rv-price]').forEach(function (p) { p.textContent = money(v.price); });
      document.querySelectorAll('[data-rv-sticky-label]').forEach(function (p) { p.textContent = money(v.price) + ' · ' + v.options.join(' · '); });
      if (v.featured_image && v.featured_image.src && main) {
        var img = main.querySelector('img');
        if (img) { img.src = v.featured_image.src; img.removeAttribute('srcset'); }
      }
      if (push) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-rv-option]')) { update(true); }
    });
    update(false);

    root.querySelectorAll('[data-rv-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = main && main.querySelector('img');
        var src = t.getAttribute('data-src');
        if (img && src) { img.src = src; img.removeAttribute('srcset'); }
      });
    });
  });

  document.querySelectorAll('[data-rv-filters]').forEach(function (g) {
    var scope = g.closest('section');
    var btns = g.querySelectorAll('[data-rv-filter]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-rv-filter');
        btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        scope.querySelectorAll('[data-size]').forEach(function (c) {
          c.hidden = !(f === 'all' || c.getAttribute('data-size') === f);
        });
      });
    });
  });
})();
